<script>
    import { Nav, NavItem, NavLink } from 'sveltestrap'

    export let asr
</script>

<style>
    .nav-link {
        cursor: pointer;
    }
</style>

<footer class="footer mt-auto py-3">
    <hr class="fno-menu-hr" />
    <Nav vertical pills>
        <NavItem>
            <NavLink
                href="https://helpdesk.snapraise.com/fanx"
                target="_blank"
            >
                Help
            </NavLink>
        </NavItem>
        <NavItem>
            <!-- Use Bootstrap native instead of NavLink so we can use on: handlers-->
            <a
                class="nav-link"
                href={asr.makePath('login')}>
                Exit TAB
            </a>
        </NavItem>
    </Nav>
</footer>
